import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from "ngx-toastr";
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileHelper {
  currentLang: string;
  constructor(
    private translateService: TranslateService,
    private toastrService: ToastrService) {

  }

  downloadFile(blob: any, filename: string) {
    
    const a = this.createFile(blob);
    a.download = filename;
    a.click();
    document.body.removeChild(a);
  }

  printFile(blob: Blob) {
    const a = this.createFile(blob);
    a.target = "_blank";
    a.click();
    document.body.removeChild(a);
  }

  createFile(blob: any): HTMLAnchorElement {
    const url = window.URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);
    a.href = url;
    return a;
  }

  handleError(x: any) {
    let errorMessage: string;
    if (x.error instanceof ErrorEvent) {
      errorMessage = this.translateService.instant('helpers.anErrorOccurred') + `${x.error.message}`;
    } else {
      errorMessage = this.translateService.instant('helpers.backendReturnedCode') + `${x.status}: ${x.body?.error || x.message || 'Unknown error'}`;
    }
    console.error(x);
    this.toastrService.error(errorMessage, this.translateService.instant('helpers.errorTitle'));
    return throwError(errorMessage);
  }
}
